<template>
  <div>
    <div class="flex flex-col items-end">
      <custom-divider margin="my-4" />
      <div class="font-medium text-color-3">
        {{ $t('PaymentLinks | totalReceivedAmount') }}
      </div>
      <div class="font-medium text-color-1 mt-1">
        {{ totalAmount }}
      </div>
    </div>

    <div class="flex gap-x-4 mt-10">
      <base-button class="!w-full" type="shade" @onClick="onCopyLink">
        <div class="flex gap-x-3">
          <svg-icon class="!w-6 !h-6" name="ic-copy" />

          <div class="font-normal">
            {{ $t('PaymentLinks | copyLink') }}
          </div>
        </div>
      </base-button>
    </div>
  </div>
</template>

<script setup>
import { defineProps, defineEmits } from 'vue'
import BaseButton from '@/shared/ui/BaseButton/BaseButton.vue'
import SvgIcon from '@/shared/ui/SvgIcon/SvgIcon.vue'
import CustomDivider from '@/shared/ui/CustomDivider/CustomDivider.vue'

defineProps({
  totalAmount: {
    type: [String, Number],
    default: 0,
  },
})

const emit = defineEmits(['copy-link'])

function onCopyLink() {
  emit('copy-link')
}
</script>
